import { getPDFLib } from './pdfLib';

export async function getPages(pdf) {
    const pdfjs = await getPDFLib();
    if (!pdfjs) throw new Error('pdfjs not available');

    const url = URL.createObjectURL(pdf);
    const loadingTask = pdfjs.getDocument({ url });
    const pdfDocument = await loadingTask.promise;

    const pages = [];
    for (let i = 1; i <= pdfDocument.numPages; i++) {
        const page = await pdfDocument.getPage(i);
        const viewport = page.getViewport({ scale: 1 });

        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvas, viewport }).promise;

        const data = canvas.toDataURL('image/png'); // 🟢 base64
        pages.push(data.replace(/^data:image\/png;base64,/, '')); // 🟢 only base64
    }

    return pages;
}